import { FormContextProvider } from 'shared-widget-components/src/providers/FormContextProvider';
import { validationSchema } from '../ValidationSchema';
interface PackagePreviewWrapperProps {
  children: JSX.Element;
}

export const PackagePreviewWrapper = ({ children }: PackagePreviewWrapperProps) => {
  return <FormContextProvider validationSchema={validationSchema}>{children}</FormContextProvider>;
};
